import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { api, ErreurApi, lire } from '../api'
import { Vide } from '../composants/Section'

// Consentement OAuth : un client MCP (Claude, par exemple) demande à agir avec vos droits.
// Rien n'est accordé sans ce clic ; la redirection va seulement à une adresse enregistrée.

type Demande = {
  client_id?: string | undefined
  redirect_uri?: string | undefined
  code_challenge?: string | undefined
  code_challenge_method?: string | undefined
  response_type?: string | undefined
  state?: string | undefined
  resource?: string | undefined
}

export function Autoriser({ demande }: { demande: Demande }) {
  const clientId = demande.client_id ?? ''
  const client = useQuery({
    queryKey: ['oauth', 'client', clientId],
    queryFn: () => lire(api.oauth.client[':id'].$get({ param: { id: clientId } })),
    enabled: Boolean(clientId),
    retry: false,
  })
  const [erreur, setErreur] = useState<string | null>(null)
  const valide =
    clientId &&
    demande.redirect_uri &&
    demande.code_challenge &&
    demande.code_challenge_method === 'S256' &&
    (demande.response_type ?? 'code') === 'code'

  async function repondre(accorde: boolean) {
    setErreur(null)
    try {
      const r = await lire(
        api.oauth.autoriser.$post({
          json: {
            clientId,
            redirectUri: demande.redirect_uri!,
            codeChallenge: demande.code_challenge!,
            codeChallengeMethod: 'S256',
            accorde,
            ...(demande.state && { state: demande.state }),
            ...(demande.resource && { resource: demande.resource }),
          },
        }),
      )
      window.location.assign(r.redirection)
    } catch (e) {
      setErreur(e instanceof ErreurApi ? e.message : 'Autorisation impossible.')
    }
  }

  if (!valide)
    return (
      <main>
        <p className="alerte">Demande d’autorisation incomplète (PKCE S256 exigé).</p>
      </main>
    )
  if (client.isPending)
    return (
      <main>
        <Vide>Chargement…</Vide>
      </main>
    )
  if (!client.data || !client.data.redirectUris.includes(demande.redirect_uri!))
    return (
      <main>
        <p className="alerte">Client inconnu ou adresse de retour non enregistrée.</p>
      </main>
    )
  const hote = new URL(demande.redirect_uri!).host

  return (
    <main className="connexion" style={{ margin: '0 auto', paddingTop: '10vh' }}>
      <h1>Autoriser l’accès</h1>
      <section className="carte section">
        <p>
          <strong>{client.data.nom}</strong> demande à consulter et à agir dans admin PMVB{' '}
          <strong>avec vos droits</strong> : lire vos échéances, paiements, pièces et tâches, créer
          ou prendre des tâches, marquer fait ou payé, trancher un rapprochement.
        </p>
        <p className="discret">
          Il ne pourra ni payer, ni déclarer, ni signer. Ses actions sont journalisées « via
          l’assistant ». Retour vers {hote}.
        </p>
        <div className="boutons">
          <button type="button" className="bouton" onClick={() => repondre(true)}>
            Autoriser
          </button>
          <button type="button" className="bouton-discret" onClick={() => repondre(false)}>
            Refuser
          </button>
        </div>
        {erreur && <p className="alerte">{erreur}</p>}
      </section>
    </main>
  )
}
